import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import logoLight from "../../assets/images/logo-dark.png";
import moment from "moment";
import "moment-timezone";
import logo from "../../assets/images/logo-sm.png";
import logoCms from "../../assets/images/LOGO CMS.png";
import logoHas from "../../assets/images/LOGO HAS.png";
import logoWAP from "../../assets/images/LOGO WAP.png";
import logoNSP from "../../assets/images/LOGO NSP.png";

import { getSalesPublicOne as onGetSalesPublicOne, resetSalesPublicState } from "../../store/salesPublic/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QRCodeSVG } from "qrcode.react";

const Starter = () => {
  const { salesId } = useParams();
  const dispatch = useDispatch();
  const { salesPublicOne, isSalesPublicSuccess } = useSelector((state) => ({
    salesPublicOne: state.SalesPublic.salesPublicOne,
    isSalesPublicSuccess: state.SalesPublic.isSalesPublicSuccess,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [salesPublic, setSalesPublic] = useState();
  const [item, setItem] = useState();

  useEffect(() => {
    if (!isSearch) {
      dispatch(onGetSalesPublicOne(salesId));
      setIsSearch(true);
    }
  }, [dispatch, isSearch, salesId]);

  const handleValidDate = (date) => {
    return moment(date).format("D MMM YYYY");
  };

  useEffect(() => {
    if (salesPublicOne) {
      setSalesPublic(salesPublicOne);
      setItem(salesPublicOne.data);
    }
  }, [salesPublicOne]);

  function currencyFormat(num) {
    return parseFloat(num).toLocaleString(["ban", "id"]);
  }

  const numRoman = (num) => {
    if (num === "1") {
      return "I";
    } else if (num === "2") {
      return "II";
    } else if (num === "3") {
      return "III";
    } else if (num === "4") {
      return "IV";
    } else if (num === "5") {
      return "V";
    } else if (num === "6") {
      return "VI";
    } else if (num === "7") {
      return "VII";
    } else if (num === "8") {
      return "VIII";
    } else if (num === "9") {
      return "IX";
    } else if (num === "10") {
      return "X";
    } else if (num === "11") {
      return "XI";
    } else if (num === "12") {
      return "XII";
    }
  };

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  document.title = "Document | Document Verification";
  return (
    <React.Fragment>
      <div className="landing p-0 m-0">
        {salesPublic && salesPublic.status === "success" && item && item.at_sales ? (
          <div>
            <div className="text-center mb-5 pb-5 pt-5 bg-soft-success">
              <div className="mb-3">
                <img src={logoLight} style={{ width: "320px" }} alt="logo light" />
              </div>
              Data Transaksi Penjualan No{" "}
              <span className="fw-semibold">
                {item.at_branch && item.at_branch.branch_code}
                {salesId.replace("sl", "")}
              </span>{" "}
              Valid dan Tercatat pada Sistem Kami
            </div>
            <div className="hero-kwitansi" style={{ padding: "20px 20px 20px 20px", width: "70%", margin: "0 auto" }}>
              {(item?.companyId === 1 || item?.companyId === 4) &&
                <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                  <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                    <img src={logoHas} alt="" height="80" width="80" />
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{item?.sales_company?.name}</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                  </div>
                </div>
              }

              {item?.companyId === 2 &&
                <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                  <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                    <img src={logoCms} alt="" height="80" width="80" />
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{item?.sales_company?.name}</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                  </div>
                </div>
              }

              {item?.companyId === 3 &&
                <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                  <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                    <img src={logoWAP} alt="" height="80" width="80" />
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{item?.sales_company?.name}</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Jl Sudarmanik Desa Jagabaya Kec. Parung Panjang, Bogor</p>
                    <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                  </div>
                </div>
              }
              <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", paddingTop: "30px", paddingBottom: "30px", display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px", fontSize: "22px", fontWeight: "bold" }}>KWITANSI</div>
              <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px" }}>{`No : ${item.at_branch && item.at_branch.branch_code}${salesId.replace("sl", "") ?? "-"}`}</div>
                <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Telah Diterima Dari</td>
                      <td style={{ width: "15px" }}>:</td>
                      <td style={{ width: "100%" }}>{item.at_sales && item?.at_sales?.sales_customer?.name}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Banyaknya Uang</td>
                      <td style={{ width: "15px" }}>:</td>
                      <td style={{ width: "100%" }}>{`${item?.amount !== null ? `${numberToWords(item?.amount)}` : "-"}`}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Untuk Pembayaran</td>
                      <td style={{ width: "15px" }}>:</td>
                      <td style={{ width: "100%" }}>{salesId ? `Sales Invoice #${item.at_branch && item.at_branch.branch_code}${item?.at_sales?.code}` : "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Keterangan</td>
                      <td style={{ width: "15px" }}>:</td>
                      <td style={{ width: "100%" }}>{item.description}</td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ flex: "1 1 0%", marginTop: "40px" }}>
                    <div style={{ display: "flex", fontSize: "18px", fontWeight: "bold" }}>
                      <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", padding: "10px 20px" }}>Jumlah</div>
                      <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", padding: "10px 20px", backgroundColor: "rgb(255, 170, 0)" }}>{`Rp. ${currencyFormat(item?.amount)}`}</div>
                    </div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <p style={{ marginTop: "30px", padding: "0", lineHeight: "0" }}>Bogor, {handleValidDate(item?.transactionat, "D MMM YYYY")}</p>
                    PT HIKMAH ALAM SENTOSA
                    <div style={{ textAlign: "center", padding: "10px 0px" }}>
                      <QRCodeSVG value={`https://pkg.pkdeveloper.id/qr/${salesId}`} size={90} bgColor={"#ffffff"} fgColor={"#000000"} level={"L"} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center mb-5">
            <div className="mb-3">
              <img src={logoLight} style={{ width: "320px" }} alt="logo light" />
            </div>
            data Penjualan <span className="fw-semibold">{salesId.replace("sl", "")}</span> tidak ditemukan
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Starter;
